import { createSelector,createSlice } from '@reduxjs/toolkit';
import { defaultFiltersWithStatus } from 'common/types/FiltersWithStatus';
import { getReducers, statusesList } from 'common/utils/statusHelpers';

import type { RootState } from '../../app/store';

const initialState = defaultFiltersWithStatus;

const licenseUsersSlice = createSlice({
    name: 'licenseUsers',
    initialState,
    reducers: getReducers()
});

// eslint-disable-next-line no-restricted-syntax
export default licenseUsersSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, checkStatusFilter } = licenseUsersSlice.actions;
export const selectFilters = (state: RootState) => state.licenseUsers.filters;

// Memoized selector to prevent unnecessary rerenders
const selectStatusKeys = (state: RootState) => state.licenseUsers.filters.dropdowns.status.keys;

export const selectFilteredStatus = createSelector(
    [selectStatusKeys],
    (statusKeys) => statusesList.filter(statusName => statusKeys.includes(statusName))
);
